import { Navigate, Outlet } from "react-router-dom";
import Footer from "../components/Footer";
import { localStorageHandler } from "../utils/helpers";
import { CONSTANTS } from "../constants/Constants";
import { useGlobalContext } from "../context/GlobalContext";
import { useEffect} from "react";

const ProtectedRoute = () => {
  const { user, setUser } = useGlobalContext();
  const token = localStorageHandler("get", CONSTANTS.LOCAL_STORAGE_KEYS.USER_TOKEN_TXT);
  useEffect(() => {
    const initializeUser = async () => {
      if (token && !user?.token) {
        const userData = localStorageHandler("get", CONSTANTS.LOCAL_STORAGE_KEYS.USER_TXT);
        if (userData) {
          setUser(userData); // Set user from localStorage
        } else {
          // Fetch user data from API if not in localStorage
          try {
            const response = await fetch(`/User/GetUserById`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            const data = await response.json();
            if (data?.success) {
              setUser(data.data);
              localStorageHandler("set", CONSTANTS.LOCAL_STORAGE_KEYS.USER_TXT, data.data);
            } else {
              console.error("Failed to fetch user data.");
            }
          } catch (error) {
            console.error("Error fetching user data:", error);
          }
        }
      }
    };

    initializeUser();
    
  }, [token, user, setUser]);

  if (!token) return <Navigate to="/login" />; // Redirect if no token

  return (
    <>
      <Outlet />
      <Footer />
    </>
  );
};

const OnlyUnauthenticatedRoute = () => {
  const { user } = useGlobalContext();
  const token = localStorageHandler("get", CONSTANTS.LOCAL_STORAGE_KEYS.USER_TOKEN_TXT);

  if (token || user?.token) {
    return <Navigate to="/dashboard" />;
  }

  return <Outlet />;
};

export { ProtectedRoute, OnlyUnauthenticatedRoute };
